// import { useState, useEffect} from 'react';

// const Nav = ({item}) => {


	
//  const sections = document.querySelectorAll("section");
//  const [ativeCategory, setAtiveCategory] = useState("#");

//  window.addEventListener("scroll",()=>{
// 		let current =""
// 		sections.forEach(section =>{

// 		const sectionTop = section.offsetTop; 
// 		const sectionHeight= section.clientHeight;
 
// 		if(window.pageYOffset >= (sectionTop - sectionHeight/7)){
// 			current=section.getAttribute("id")
// 			setAtiveCategory(`#${current}`)
// 		} 
// 	})
// 	})

// 	console.log("section id", ativeCategory)
// 	console.log("item link", item.link )

// 	useEffect(() => {
//     setAtiveCategory(window.location.href)
//   }, [])

	
	
// 	return (
// 		<li className={ativeCategory === item.link ? "active" : ativeCategory === "#" ? "active": "no-active" }>
// 			<a href={item.link}>{item.icon}
// 			</a>
// 		</li>
// 	)
// }

// export default Nav

const Nav = ({className, item}) => {

	return (
		<li className={className}><a href={item.link}>{item.icon}</a></li>
	)
}

export default Nav